const DASHBOARD_SEARCH_Q_MAX = 128

export function clampDashboardSearchQuery(q: string): string {
  return q.trim().slice(0, DASHBOARD_SEARCH_Q_MAX)
}
